/**
 * Appends html to the body
 *
 * @param htmlStrings - params of html in string format
 */
const appendToDocumentBody = (...htmlStrings: string[]) => {
  const div = document.createElement('div');

  div.innerHTML = htmlStrings.join('');

  Array.from(div.children).forEach((child) => {
    document.body.appendChild(child);
  });
};

export default appendToDocumentBody;
